<!--
    Styles
-->

<style scoped>


    /* main */

    .search {
        position: relative;
    }


    /* input */

    .search .input {
        height: 34px;
    }
    .search .input svg.close {
        cursor: pointer;
    }


</style>



<!--
    Template
-->

<template>
    <div class="search">


        <!-- input -->

        <ui-search class="input" :class="{focus}" v-focus="focus" v-model="input" @enter="search">
            <icon-close class="close cl-blue" v-show="input" @click="clear()" @mousedown.prevent />
        </ui-search>


    </div>
</template>



<!--
    Scripts
-->

<script>


    import focus from '@/common/directives/focus'
    import uiSearch from '@/components/shared/ui/search.vue'
    import iconClose from '@/assets/icons/close.svg'


    export default {

        components: {
            iconClose,
            uiSearch,
        },

        directives: {
            focus
        },

        data () {

            return {
                input: null,
                focus: false
            }
        },

        methods: {

            search () {
                this.$router.push({
                    name: this.$route.name,
                    query: {
                        ...this.$route.query,
                        search: this.input || undefined
                    }
                });
            },


            clear () {
                this.input = null;
                this.focus = true;
            }

        }

    }

</script>
